import { ChildrenProps } from '../../../common/model';
import './style.scss';

export const View = (props: ChildrenProps) => {
    const { children } = props;
    return <>{children}</>;
};
